/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-06-27 15:34:48
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-09-30 10:42:07
 * @FilePath: \front_admin\src\router\modules\school\index.js
 * @Description: 学堂后台(猪哥学堂)
 */
// 直播管理
const liveCourse = () => import('@/components/college/pigSchool/index');
const addLive = () => import('@/components/college/pigSchool/addLive');
// 消息管理
const deploy = () => import('@/components/college/news/deploy/index');
const notice = () => import('@/components/college/news/notice/index');
const modifyNew = () => import('@/components/college/news/notice/modify');
const detailNew = () => import('@/components/college/news/notice/detail');
const noteRecord = () => import('@/components/college/news/record/index');
// 财务中心
const dealDetail = () => import('@/components/college/finance/index');

const classify = () => import('@/components/platform/school/classify');
const classManage = () => import('@/components/platform/school/manage');
const userManage = () => import('@/components/platform/school/userManage');
const orderManage = () => import('@/components/platform/school/orderManage/index');
const orderJF = () => import('@/components/platform/school/orderManage/orderJF.vue');
const orderVip = () => import('@/components/platform/school/orderManage/orderVip.vue');

const addCourse = () => import('@/components/platform/school/components/addCourse'); //新增课程页面
const teacherManage = () => import('@/components/platform/school/teacherManage.vue'); //新增课程页面
const commentManage = () => import('@/components/platform/school/commentManage.vue'); //评价审核
//活动管理  
const timeFree = () => import('@/components/platform/school/activityAdmin/timeFree.vue'); //限时免费
const addFree = () => import('@/components/platform/school/activityAdmin/components/addFree.vue');
const sharePoliteness = () => import('@/components/platform/school/activityAdmin/sharePoliteness.vue'); //分享有礼
const addShare = () => import('@/components/platform/school/activityAdmin/components/addShare.vue');

//学堂轮播管理
const rotation = () => import('@/components/school/rotation/index');
const schoolLink = () => import('@/components/school/link/index');
const newsSchool = () => import('@/components/school/news/index');
const jooSchool = () => import('@/components/school/jooSchool/index'); // 首页布局

// 学堂logo
const schoolLogo = () => import('@/components/college/schoolLogo/index');
// 兴趣标签
const hobby = () => import('@/components/college/interest/hobby/index'); //兴趣爱好
const interestClassify = () => import('@/components/college/interest/interestClassify/index'); //兴趣分类

// H5页面管理
const H5Page = () => import('@/components/college/H5Page/index');
const courseGet = () => import('@/components/college/H5Page/components/courseGet');

// 会员管理
const memberManage = () => import('@/components/college/memberManage/level/index');
const addLevel = () => import('@/components/college/memberManage/level/addLevel');
const coupons = () => import('@/components/college/memberManage/coupons/index');
const editCoupons = () => import('@/components/college/memberManage/coupons/editCoupons');
const equities = () => import('@/components/college/memberManage/equities/index');

// 积分
const jftask = () => import('@/components/college/memberManage/JFtask/index');
const editTask = () => import('@/components/college/memberManage/JFtask/editTask.vue');

//签到

const singIn = () => import('@/components/college/singIn/index');
const manageSign = () => import('@/components/college/singIn/manageSign.vue');

const schoolHome = () => import('@/components/college/schoolHome/index'); //首页内容

export default [{
    path: '/liveCourse',
    name: 'liveCourse',
    meta: {
      belong: ['school'],
      text: '直播课程',
    },
    component: liveCourse,
  },
  {
    path: '/addLive',
    name: 'addLive',
    meta: {
      belong: ['school'],
      text: '新增直播',
    },
    component: addLive,
  },
  {
    path: '/deploy',
    name: 'deploy',
    meta: {
      belong: ['school'],
      text: '消息配置',
    },
    component: deploy,
  },
  {
    path: '/notice',
    name: 'notice',
    meta: {
      belong: ['school'],
      text: '公告消息',
    },
    component: notice,
  },
  {
    path: "/modifyNew",
    name: "modifyNew",
    component: modifyNew,
    meta: {
      belong: ['school'],
      text: '公告消息'
    }
  },
  {
    path: "/detailNew",
    name: "detailNew",
    component: detailNew,
    meta: {
      belong: ['school'],
      text: '公告详情'
    }
  },
  {
    path: '/noteRecord',
    name: 'noteRecord',
    meta: {
      belong: ['school'],
      text: '短信记录',
    },
    component: noteRecord,
  },
  {
    path: '/dealDetail',
    name: 'dealDetail',
    meta: {
      belong: ['school'],
      text: '交易明细',
    },
    component: dealDetail,
  },
  {
    path: '/classify',
    name: 'classify',
    meta: {
      belong: ['school'],
      text: '课程分类',
    },
    component: classify,
  }, {
    path: '/classManage',
    name: 'classManage',
    meta: {
      belong: ['school'],
      text: '课程管理',
    },
    component: classManage,

  }, {
    path: '/addCourse',
    name: 'addCourse',
    meta: {
      belong: ['school'],
      text: '新增课程',
    },
    component: addCourse,
  }, {
    path: '/orderManage',
    name: 'orderManage',
    meta: {
      belong: ['school'],
      text: '订单管理',
    },
    component: orderManage,
  },
  {
    path: '/orderJF',
    name: 'orderJF',
    meta: {
      belong: ['school'],
      text: '积分兑换',
    },
    component: orderJF,
  }, {
    path: '/orderVip',
    name: 'orderVip',
    meta: {
      belong: ['school'],
      text: '会员订单',
    },
    component: orderVip,
  }, {
    path: '/userManage',
    name: 'userManage',
    meta: {
      belong: ['school'],
      text: '用户管理',
    },
    component: userManage,
  }, {
    path: '/teacherManage',
    name: 'teacherManage',
    meta: {
      belong: ['school'],
      text: '讲师管理',
    },
    component: teacherManage,
  },
  {
    path: '/timeFree',
    name: 'timeFree',
    meta: {
      belong: ['school'],
      text: '限时免费',
    },
    component: timeFree,
  },
  {
    path: '/addFree',
    name: 'addFree',
    meta: {
      belong: ['school'],
      text: '新增限时免费',
    },
    component: addFree,
  },
  {
    path: '/sharePoliteness',
    name: 'sharePoliteness',
    meta: {
      belong: ['school'],
      text: '分享有礼',
    },
    component: sharePoliteness,
  },
  {
    path: '/addShare',
    name: 'addShare',
    meta: {
      belong: ['school'],
      text: '新增分享',
    },
    component: addShare,
  },
  {
    path: '/commentManage',
    name: 'commentManage',
    meta: {
      belong: ['school'],
      text: '评价审核',
    },
    component: commentManage,
  },
  {
    path: '/rotation',
    name: 'rotation',
    meta: {
      belong: ['school'],
      text: '轮播管理',
    },
    component: rotation,
  },
  {
    path: '/schoolLink',
    name: 'schoolLink',
    meta: {
      belong: ['school'],
      text: '友情链接',
    },
    component: schoolLink,
  },
  {
    path: '/newsSchool',
    name: 'newsSchool',
    meta: {
      belong: ['school'],
      text: '咨询管理',
    },
    component: newsSchool,
  },
  {
    path: '/jooSchool',
    name: 'jooSchool',
    meta: {
      belong: ['school'],
      text: '首页布局',
    },
    component: jooSchool,
  },
  {
    path: '/schoolLogo',
    name: 'schoolLogo',
    meta: {
      belong: ['school'],
      text: '学堂logo',
    },
    component: schoolLogo,
  },
  {
    path: '/hobby',
    name: 'hobby',
    meta: {
      belong: ['school'],
      text: '兴趣爱好',
    },
    component: hobby,
  },
  {
    path: '/interestClassify',
    name: 'interestClassify',
    meta: {
      belong: ['school'],
      text: '兴趣分类',
    },
    component: interestClassify,
  },
  {
    path: '/H5Page',
    name: 'H5Page',
    meta: {
      belong: ['school'],
      text: 'H5页面管理',
    },
    component: H5Page,
  },
  {
    path: '/courseGet',
    name: 'courseGet',
    meta: {
      belong: ['school'],
      text: '课程领取',
    },
    component: courseGet,
  },
  {
    path: '/memberManage',
    name: 'memberManage',
    meta: {
      belong: ['school'],
      text: '会员等级',
    },
    component: memberManage,
  },
  {
    path: '/addLevel',
    name: 'addLevel',
    meta: {
      belong: ['school'],
      text: '添加等级',
    },
    component: addLevel,
  },
  {
    path: '/coupons',
    name: 'coupons',
    meta: {
      belong: ['school'],
      text: '会员券',
    },
    component: coupons,
  },
  {
    path: '/editCoupons',
    name: 'editCoupons',
    meta: {
      belong: ['school'],
      text: '添加会员券',
    },
    component: editCoupons,
  },
  {
    path: '/equities',
    name: 'equities',
    meta: {
      belong: ['school'],
      text: '会员权益',
    },
    component: equities,
  },
  {
    path: '/jftask',
    name: 'jftask',
    meta: {
      belong: ['school'],
      text: '积分任务',
    },
    component: jftask,
  },
  {
    path: '/jftask/editTask',
    name: 'editTask',
    meta: {
      belong: ['school'],
      text: '编辑积分',
    },
    component: editTask,
  },
  {
    path: '/singIn',
    name: 'singIn',
    meta: {
      belong: ['school'],
      text: '签到管理',
    },
    component: singIn,
  },
  {
    path: '/manageSign',
    name: 'manageSign',
    meta: {
      belong: ['school'],
      text: '签到规则',
    },
    component: manageSign,
  },
  {
    path: '/schoolHome',
    name: 'schoolHome',
    meta: {
      belong: ['school'],
      text: '首页内容',
    },
    component: schoolHome,
  },

]
